import React, { useEffect, useState } from 'react';
import StudentWrapper from '../../StudentWrapper';
import Button from '../../../components/Button';
import AddDetails from '../../studentDetails/AddDetails';
import { Link } from 'react-router-dom';
import Loader from '../../../components/Loader/Loader';
import Input from '../../../components/Input';
const StudentDashboard = () => {
  const [open, setOpen] = useState(false);
  const [course, setCourse] = useState([]);
  const [myenrollment, setMyenrollment] = useState('');
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCourses = course.filter((course) => {
    const matchesSearchQuery =
      course?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      course?.course?.name?.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearchQuery;
  });

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/user/course', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log(data?.courses);
        setCourse(data?.courses);
        setLoading(false);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    let data = JSON.parse(userData);

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      email: data?.email
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/user/my-course', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("DATA", data.data);
        setMyenrollment(data?.data?.length);
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <StudentWrapper
      searchBar={
        <Input
          placeholder={`Search by  course name...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img
              src={require('../../../assets/image/Search-Magnifier.png')}
              className=" w-8"
              alt=""
            />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <AddDetails setIsModalOpen={setOpen} isModalOpen={open} />
      <div className=" ">
        <h2 className="main_title ">Dashboard</h2>
        <p className=" text-[#1C1D1D]">Here overview of the courses</p>
      </div>

      <section className=" pt-2">
        <div className=" py-4  w-full grid  grid-cols-1  xl:grid-cols-3 md:grid-cols-2 gap-5">
          <div className=" w-full">
            <div
              className="  bg-white p-5 rounded-lg flex  justify-between"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Total Enrolled</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3  text-[#1C1D1D]">{myenrollment}</p>
                </div>
              </div>
              <div>
                <img src={require('../../../assets/image/active.png')} alt="" />
              </div>
            </div>
          </div>
          {/* <div className=" w-full">
            <div
              className=" bg-white  flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Completed</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">50</p>
                </div>
              </div>
              <div>
                <img src={require('../../../assets/image/completed.png')} alt="" />
              </div>
            </div>
          </div> */}
          {/* <div className=" w-full">
            <div
              className=" bg-white  text-black flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Total Cources</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{myenrollment}</p>
                </div>
              </div>
              <div>
                <img src={require('../../../assets/image/ongoing.png')} alt="" />
              </div>
            </div>
          </div> */}
        </div>
      </section>

      <section>
        <h1 className=" text-xl mt-4 text-[#1C1D1D] font-semibold">Available Cources</h1>

        {loading ? (
          <Loader /> // Show the loader while fetching courses
        ) : (
          <>
            {course && course.length > 0 ? (
              <>
                {filteredCourses.map((course) => (
                  <div className=" grid grid-cols-1 mt-4 gap-6">
                    <Link
                      to={`/cource-details/${course?._id}`}
                      className=" bg-white flex md:flex-row flex-col  rounded-lg gap-4"
                      style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                    >
                      <div className="md:w-3/12 w-12/12">
                        <img
                          src={course?.image}
                          className="w-full h-full object-cover rounded-lg"
                          alt=""
                        />
                      </div>

                      <div className=" md:w-8/12 w-12/12 p-4">
                        <h6 className=" pt-3 text-lg">{course?.name}</h6>
                        <div className=" flex gap-5 pt-2  items-center">
                          <div className=" flex gap-1 items-center">
                            <div>
                              <img src={require('../../../assets/image/Form.png')} alt="" />
                            </div>
                            <p>{course?.lesson} Lesson</p>
                          </div>

                          <div className=" flex gap-1 items-center">
                            <div>
                              <img
                                src={require('../../../assets/image/Graduation Cap.png')}
                                alt=""
                              />
                            </div>
                            <p>{course?.duration}</p>
                            <p>{course?.periodType}</p>
                          </div>
                        </div>
                        <p className=" pt-2 text-sm">{course?.description}</p>
                        <Button
                          label={'Enroll Now'}
                          className={' bg-secondary text-white mt-2 w-36'}
                        />
                      </div>
                    </Link>
                  </div>
                ))}
              </>
            ) : (
              <>
                <div className="text-center mt-8">
                  <p className="text-gray-600 text-lg">No courses available at the moment.</p>
                </div>
              </>
            )}
          </>
        )}
      </section>
    </StudentWrapper>
  );
};

export default StudentDashboard;
